import axios from 'axios'

export const listDictByType = (type) => {
    return axios({
        method: "get",
        url: "/v1/web/dictItem/listByType/" + type,
    })
}
